module.exports = __webpack_public_path__ + "img/bandeau-JPO-2.7b70d4d.png";